import { PDFDocument } from 'pdf-lib';

// … inside your component …

/**
 * Take an array of Blob PDFs and return a single merged Blob.
 */
async function mergeBlobsToPdf(blobs) {
  // 1. Create a new empty PDFDocument
  const mergedPdf = await PDFDocument.create();

  // 2. Loop through each blob, load it, copy its pages
  for (const blob of blobs) {
    const uint8Array = new Uint8Array(await blob.arrayBuffer());
    const pdf = await PDFDocument.load(uint8Array);
    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    copiedPages.forEach(page => mergedPdf.addPage(page));
  }

  // 3. Serialize the merged document to Uint8Array
  const mergedBytes = await mergedPdf.save();
  // 4. Wrap in a Blob
  return new Blob([mergedBytes], { type: 'application/pdf' });
}

export default mergeBlobsToPdf